import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { useGetMaster } from '../../../../api/masters/masters';
import { useDefaultOptions } from '../../../../hooks/api';
import { MasterForm } from './MasterForm';

/**
 * タブタイトル
 * @returns
 */
function Title() {
  // 言語情報
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('CMS-POC|マスタ情報')}</title>
    </Helmet>
  );
}
function MasterFormPage() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { masterVersionId } = useParams();
  const options = useDefaultOptions(language);

  const masterResponse = useGetMaster(Number(masterVersionId), options);

  if (masterVersionId == null) {
    return <div id="main">{t('この URL は存在しません。')}</div>;
  }

  const master = masterResponse.data?.data;
  if (!master) {
    return <div id="main">{t('お待ちください。')}</div>;
  }

  return (
    <div id="main">
      <Title />
      <MasterForm master={master} />
    </div>
  );
}

export default MasterFormPage;
